<template>
  <div class="page-pdf page-export-val page-export-val--horizontal mb-2">
    <div class="container-title-page-report">
      {{ title }}
      <div class="container-header-page">
        <a href="https://www.brainsre.com/" target="_blank">
          <img v-if="logo" id="imglogo" :src="logo" alt="">
        </a>
      </div>
    </div>
    <div class="container-page-features">
      <pageHeaderContent />
    </div>
    <div class="container-content-page">
      <slot />
    </div>
  </div>
</template>

<script>
import logo from '@/assets/logo.png'
import pageHeaderContent from './pageHeaderContent'

export default {
  name: 'PageExportVal',
  components: { pageHeaderContent },
  props: {
    title: {
      type: String,
      default: 'Page Export Val title'
    }
  },
  data() {
    return {
      logo: logo
    }
  },
  computed: {},
  watch: {},
  mounted: function() {},

  methods: {}
}
</script>

<style lang="scss">
.page-export-val--horizontal {
  //   width: 1366px;
  //   height: 764px;
  width: 1600px;
  height: 895px;
  border: 1px solid black;
  padding: 20px;
  font-family: "Montserrat-Regular",sans-serif;
  background-color: white;

  .container-content-page {
    width: 100%;
    overflow: hidden;
  }

  .container-title-page-report {
    font-size: 30px;
    font-family: "Montserrat-ExtraBold",sans-serif;
    margin: 0 300px 15px 0;
    padding-bottom: 5px;
    border-bottom: 8px solid #1e3cff;
    position: relative;
    display: flex;
    align-items: center;

    .container-header-page {
      position: absolute;
      right: -277px;
      padding-top: 2px;

      a img {
        max-height: 60px;
      }
    }
  }

  .container-page-features {
    margin-bottom: 15px;
  }
}

.page-export-val {
    display: grid;
    grid-template-rows: 55px 100px auto;
}
</style>
